import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  return <section className="bg-brand-cream min-h-screen flex items-center pt-20 pb-16 px-6 relative overflow-hidden" data-id="element-102">
      <div className="max-w-5xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-103">
        <motion.div initial="hidden" animate="visible" variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }} className="order-2 lg:order-1 text-center lg:text-left" data-id="element-104">
          <motion.h1 variants={fadeInUp} className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-charcoal leading-tight mb-6" data-id="element-105">
            Detén el sofoco en 90 segundos antes de que alguien lo note.
          </motion.h1>

          <motion.p variants={fadeInUp} className="font-sans text-lg md:text-xl text-brand-charcoal/80 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-106">
            El protocolo de emergencia discreto para mujeres profesionales que
            no tienen tiempo (ni ganas) de sudar en público.
          </motion.p>

          <motion.div variants={fadeInUp} data-id="element-107">
            <CTAButton label="Empezar mi plan" data-id="element-108" />
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 relative flex justify-center" data-id="element-109">
          <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden shadow-2xl" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/6K6jhc5pcw2jdqjNsD83yX/Menopausia_sin_Niebla.png" alt="Manual Menopausia sin Niebla" className="w-full h-full object-cover" data-id="element-111" />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-2xl" data-id="element-112"></div>
          </div>
          {/* Decorative background element */}
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-sage rounded-full blur-3xl opacity-50" data-id="element-113"></div>
        </motion.div>
      </div>
    </section>;
}